import { render, staticRenderFns } from "./ActionMenu.vue?vue&type=template&id=520c6339"
import script from "./actionmenu.js?vue&type=script&lang=js&external"
export * from "./actionmenu.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports